"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParamPersistedInLocalStorage = exports.persistParamInLocalStorage = exports.isParamPersistedInCookies = exports.persistParamInCookies = void 0;
const cookie = __importStar(require("cookie"));
const local_storage_helper_1 = require("./local-storage-helper");
const TTL = 11 * 60 * 60 * 1000; // 11 hours in milliseconds
// Map of paramKeys to their respective cookie names
const cookieNames = {
    A: 'Drupal.visitor.novasol_partner_id',
    Theme: 'myPartnerCookie',
};
/**
 * Persists a parameter in cookies.
 * @param paramKey - The name of the parameter (e.g., 'A' or 'Theme')
 * @param paramValue - The value to set in the cookie
 * @param setCookie - Function to set a cookie, typically for server usage
 */
const persistParamInCookies = (paramKey, paramValue, setCookie) => {
    const cookieName = cookieNames[paramKey];
    if (paramValue && cookieName) {
        const cookieString = cookie.serialize(cookieName, paramValue, {
            path: '/',
            expires: new Date(Date.now() + TTL),
        });
        // On the client, set the cookie directly; on the server, use setCookie if provided
        if (typeof document !== 'undefined') {
            document.cookie = cookieString;
        }
        else if (setCookie) {
            setCookie(cookieName, paramValue, {
                path: '/',
                expires: new Date(Date.now() + TTL),
            });
        }
    }
};
exports.persistParamInCookies = persistParamInCookies;
/**
 * Checks if a parameter is already persisted in cookies.
 * @param paramKey - The name of the parameter to check (e.g., 'A' or 'Theme')
 * @returns Boolean indicating if the parameter exists in cookies
 */
const isParamPersistedInCookies = (paramKey) => {
    if (typeof document === 'undefined')
        return false;
    const cookieName = cookieNames[paramKey];
    const cookies = cookie.parse(document.cookie);
    return !!cookies[cookieName];
};
exports.isParamPersistedInCookies = isParamPersistedInCookies;
/**
 * Persists a parameter in localStorage with TTL.
 * @param paramKey - The name of the parameter (e.g., 'A' or 'Theme')
 * @param paramValue - The value to store in localStorage
 */
const persistParamInLocalStorage = (paramKey, paramValue) => {
    if (paramValue) {
        (0, local_storage_helper_1.setItemWithTTL)(paramKey, paramValue, TTL);
    }
};
exports.persistParamInLocalStorage = persistParamInLocalStorage;
/**
 * Checks if a parameter is already persisted in localStorage.
 * @param paramKey - The name of the parameter to check (e.g., 'A' or 'Theme')
 * @returns Boolean indicating if the parameter exists in localStorage
 */
const isParamPersistedInLocalStorage = (paramKey) => {
    return !!(0, local_storage_helper_1.getItemWithTTL)(paramKey);
};
exports.isParamPersistedInLocalStorage = isParamPersistedInLocalStorage;
//# sourceMappingURL=agency-param-tracker-helper.js.map